// extracted by mini-css-extract-plugin
export default {"labelAndInput":"style_labelAndInput__bf4nF","bigTextarea":"style_bigTextarea__MF0MC","normalTextarea":"style_normalTextarea__ioPLn"};